import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { ButtonComponent } from '../../../shared/components/button/button.component';
import { ModalComponent } from '../../../shared/components/modal/modal/modal.component';
import { toFullDate } from '../../../utils/date';
import { LegalDocument } from '../../model/LegalDocument';
import { LegalDocumentApproval } from '../../model/LegalDocumentApproval';

@Component({
    selector: 'app-approved-legal-documents-modal',
    imports: [ModalComponent, ButtonComponent, TranslatePipe],
    templateUrl: './approved-legal-documents-modal.component.html',
    styleUrl: './approved-legal-documents-modal.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ApprovedLegalDocumentsModalComponent {
    readonly open = input<boolean>(false);
    readonly legalDocumentApproval = input<LegalDocumentApproval>();

    readonly closed = output<void>();
    readonly documentDownloaded = output<LegalDocument>();

    protected readonly documents = computed<LegalDocument[]>(
        () => this.legalDocumentApproval()?.approvedDocuments ?? [],
    );
    protected readonly approvalDate = computed<string>(() => {
        const date = this.legalDocumentApproval()?.approvalDate;
        return date ? toFullDate(date) : '';
    });
}
